var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.04163 27.125C8.33121 27.125 7.72305 26.872 7.21715 26.3661C6.71124 25.8602 6.45829 25.2521 6.45829 24.5417V7.75H5.16663V5.16667H11.625V3.875H19.375V5.16667H25.8333V7.75H24.5416V24.5417C24.5416 25.2521 24.2887 25.8602 23.7828 26.3661C23.2769 26.872 22.6687 27.125 21.9583 27.125H9.04163ZM21.9583 7.75H9.04163V24.5417H21.9583V7.75ZM11.625 21.9583H14.2083V10.3333H11.625V21.9583ZM16.7916 21.9583H19.375V10.3333H16.7916V21.9583Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.ddef48045d293d3c5bc8d085b9ab5e45.svg";
export { ForwardRef as ReactComponent };